// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdv-200 {
  background-color: #2E7D32;
  color: white;
}

.cdv-201 {
  background-color: #0EA501;
  color: white;
}

.cdv-202 {
  background-color: #7CB342;
  color: white;
}

.cdv-203 {
  background-color: #1976D2;
  color: white;
}

.cdv-204 {
  background-color: #FFA500;
  color: white;
}

.cdv-205 {
  background-color: #1B5E20;
  color: white;
}

.cdv-206 {
  background-color: #FFB300;
  color: white;
}

.cdv-207 {
  background-color: #C2185B;
  color: white;
}

.cdv-208 {
  background-color: #6A1B9A;
  color: white;
}

.cdv-209 {
  background-color: #004D40;
  color: white;
}

.cdv-210 {
  background-color: #D32F2F;
  color: white;
}

.cdv-211 {
  background-color: #3949AB;
  color: white;
}

.cdv-212 {
  background-color: #00897B;
  color: white;
}

.cdv-213 {
  background-color: #263238;
  color: white;
}

:host #loader {
  display: block;
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #35364A;
  animation: spin 2s linear infinite;
}
:host #loader:before {
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #35364A;
  animation: spin 3s linear infinite;
}
:host #loader:after {
  content: "";
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #35364A;
  animation: spin 1.5s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
:host .hse-splash-screen {
  background-color: rgba(52, 58, 64, 0.8);
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  z-index: 9999;
  top: 0;
  bottom: 0;
}
:host .hse-splash-screen img {
  margin-left: calc(100vw - 100%);
  width: 90px;
  margin-bottom: 30px;
}
:host .hse-splash-screen span {
  margin-left: calc(100vw - 100%);
  margin-bottom: 30px;
}
:host .hse-splash-screen ::ng-deep .mat-progress-spinner circle,
:host .hse-splash-screen ::ng-deep .mat-spinner circle {
  stroke: #5d78ff;
}`, "",{"version":3,"sources":["webpack://./src/scss/_variables.scss","webpack://./src/app/components/spinner/spinner.component.scss"],"names":[],"mappings":"AA0BA;EAAW,yBAAA;EAA2B,YAAA;ACvBtC;;ADwBA;EAAW,yBAAA;EAA2B,YAAA;ACnBtC;;ADoBA;EAAW,yBAAA;EAA2B,YAAA;ACftC;;ADgBA;EAAW,yBAAA;EAA2B,YAAA;ACXtC;;ADYA;EAAW,yBAAA;EAA2B,YAAA;ACPtC;;ADQA;EAAW,yBAAA;EAA2B,YAAA;ACHtC;;ADIA;EAAW,yBAAA;EAA2B,YAAA;ACCtC;;ADAA;EAAW,yBAAA;EAA2B,YAAA;ACKtC;;ADJA;EAAW,yBAAA;EAA2B,YAAA;ACStC;;ADRA;EAAW,yBAAA;EAA2B,YAAA;ACatC;;ADZA;EAAW,yBAAA;EAA2B,YAAA;ACiBtC;;ADhBA;EAAW,yBAAA;EAA2B,YAAA;ACqBtC;;ADpBA;EAAW,yBAAA;EAA2B,YAAA;ACyBtC;;ADxBA;EAAW,yBAAA;EAA2B,YAAA;AC6BtC;;AAjEE;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBDTgB;ECWhB,kCAAA;AAoEJ;AAjEE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBDvBgB;ECyBhB,kCAAA;AAmEJ;AAhEE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBDrCgB;ECuChB,oCAAA;AAkEJ;AAjDE;EACE;IAGE,uBAAA;EA+DJ;EA5DE;IAGE,yBAAA;EA8DJ;AACF;AA3DE;EACE,uCAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;AA6DJ;AA3DI;EACE,+BAAA;EACA,WAAA;EACA,mBAAA;AA6DN;AA1DI;EACE,+BAAA;EACA,mBAAA;AA4DN;AAvDM;;EAGE,eAAA;AAwDR","sourcesContent":["// Variabile che è possibile richiamare dagli altri file scss\r\n$mat-primary-color: #35364A;\r\n\r\n$mat-secondary-color: #35364A;\r\n\r\n$navbar-text-selected: #00857E;\r\n\r\n$navbar-gray-text: #555667;\r\n\r\n$navbar-white-text: #FFFF;\r\n\r\n$error-color: #B50600;\r\n$warning-color: #C65015;\r\n$success-color: #056E4B;\r\n\r\n\r\n// Larghezza della sidebar\r\n$navbar-brand-width: 300px !default;\r\n$sidebar-width: 300px !default;\r\n\r\n// Logica usata\r\n//  Verde → esito positivo\r\n//  Blu → stato informativo / di sistema\r\n//  Arancio / Giallo → attenzione / transizione\r\n//  Rosso / Nero → rifiuti\r\n\r\n.cdv-200 { background-color: #2E7D32; color: white; } \r\n.cdv-201 { background-color: #0EA501; color: white; } \r\n.cdv-202 { background-color: #7CB342; color: white; } \r\n.cdv-203 { background-color: #1976D2; color: white; } \r\n.cdv-204 { background-color: #FFA500; color: white; } \r\n.cdv-205 { background-color: #1B5E20; color: white; } \r\n.cdv-206 { background-color: #FFB300; color: white; } \r\n.cdv-207 { background-color: #C2185B; color: white; } \r\n.cdv-208 { background-color: #6A1B9A; color: white; } \r\n.cdv-209 { background-color: #004D40; color: white; } \r\n.cdv-210 { background-color: #D32F2F; color: white; } \r\n.cdv-211 { background-color: #3949AB; color: white; } \r\n.cdv-212 { background-color: #00897B; color: white; } \r\n.cdv-213 { background-color: #263238; color: white; } ","@import '../../../scss/variables';\r\n\r\n:host {\r\n  #loader {\r\n    display: block;\r\n    position: relative;\r\n    width: 150px;\r\n    height: 150px;\r\n    border-radius: 50%;\r\n    border: 3px solid transparent;\r\n    border-top-color: $mat-primary-color;\r\n    -webkit-animation: spin 2s linear infinite;\r\n    animation: spin 2s linear infinite;\r\n  }\r\n\r\n  #loader:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 5px;\r\n    right: 5px;\r\n    bottom: 5px;\r\n    border-radius: 50%;\r\n    border: 3px solid transparent;\r\n    border-top-color: $mat-primary-color;\r\n    -webkit-animation: spin 3s linear infinite;\r\n    animation: spin 3s linear infinite;\r\n  }\r\n\r\n  #loader:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 15px;\r\n    left: 15px;\r\n    right: 15px;\r\n    bottom: 15px;\r\n    border-radius: 50%;\r\n    border: 3px solid transparent;\r\n    border-top-color: $mat-primary-color;\r\n    -webkit-animation: spin 1.5s linear infinite;\r\n    animation: spin 1.5s linear infinite;\r\n  }\r\n\r\n  @-webkit-keyframes spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n      -ms-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n      -ms-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  @keyframes spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n      -ms-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n      -ms-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  .hse-splash-screen {\r\n    background-color: #343a40cc;\r\n    position: fixed;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 9999;\r\n    top: 0;\r\n    bottom: 0;\r\n\r\n    img {\r\n      margin-left: calc(100vw - 100%);\r\n      width: 90px;\r\n      margin-bottom: 30px;\r\n    }\r\n\r\n    span {\r\n      margin-left: calc(100vw - 100%);\r\n      margin-bottom: 30px;\r\n    }\r\n\r\n    ::ng-deep {\r\n\r\n      .mat-progress-spinner circle,\r\n      .mat-spinner circle {\r\n        // brand color\r\n        stroke: #5d78ff;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
